import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { DialogService } from 'ng2-bootstrap-modal';
import { environment } from '../../environments/environment';
import { APIURLS, SHAREDCONSTANTS } from '../_constants/constants';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Injectable()
export class SuccessfullLoginService {    

    constructor(private http: Http, private ds: DialogService) {
    }


    getLastSuccessfullLoginData(page: number, subValue: string, opcoValue: string, itemsPerPage:number, offset:number): Observable<any> {        

        const params = new URLSearchParams();
        const URL = (environment.BASE_URL_BACKEND + APIURLS.MC_CONNECT_per_service_data).replace('{sub}', subValue);
        
        params.append("offset", String(offset));
        params.append("count", String(itemsPerPage));
        params.append("sort", "timeOfRequest:desc");
        params.append("mobileconnect", "true");        

        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        const options = new RequestOptions({ headers: headers, withCredentials: true, search: params });


         return this.http.get(URL, options).map(response => response.json());             
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/successfull.login.service.ts